import { httpClient, getAuthToken, API_BASE_URL } from './core';

export interface GiftVoucherPurchaseDto {
  id: number;
  status: 'pending' | 'paid' | 'failed' | 'refunded' | 'cancelled';
  amountCents: number;
  currency: string;
  buyerEmail: string;
  buyerName: string;
  recipientEmail: string | null;
  recipientName: string | null;
  von: string;
  fuer: string;
  grusstext: string | null;
  themeSlug: 'weihnachten' | 'geburtstag' | 'valentinstag' | 'neutral';
  deliveryMode: 'buyer' | 'recipient';
  scheduledSendAt: string | null;
  sentAt: string | null;
  sendAttempts: number;
  lastSendError: string | null;
  standortId: number | null;
  standortName: string | null;
  stripePaymentIntentId: string | null;
  marketingCouponCodeId: number | null;
  couponCode: string | null;
  redemptionCount: number;
  refundedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface GiftVoucherStatsDto {
  totalCount: number;
  paidCount: number;
  paidAmountCents: number;
  refundedAmountCents: number;
  redeemedCount: number;
  outstandingAmountCents: number;
  byTheme: Array<{ theme: string; count: number; amountCents: number }>;
  byStandort: Array<{ standortId: number | null; standortName: string | null; count: number; amountCents: number }>;
}

export const giftVouchersApi = {
  list: async (): Promise<GiftVoucherPurchaseDto[]> => {
    const res = await httpClient<{ items: GiftVoucherPurchaseDto[] }>('/api/gift-vouchers');
    if (res.error) throw new Error(res.error);
    return res.data?.items || [];
  },

  stats: async (): Promise<GiftVoucherStatsDto> => {
    const res = await httpClient<GiftVoucherStatsDto>('/api/gift-vouchers/stats');
    if (res.error || !res.data) throw new Error(res.error || 'Statistik konnte nicht geladen werden');
    return res.data;
  },

  pdfUrl: (id: number): string => `${API_BASE_URL}/api/gift-vouchers/${id}/pdf`,

  openPdf: (id: number): void => {
    const token = getAuthToken();
    const url = giftVouchersApi.pdfUrl(id);
    // Fetch + Blob, damit der JWT-Header mitgeschickt wird
    fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((r) => r.blob())
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      })
      .catch(() => {
        // Fallback: direkt öffnen (ohne Auth)
        window.open(url, '_blank');
      });
  },

  resend: async (id: number): Promise<void> => {
    const res = await httpClient<{ ok: boolean }>(`/api/gift-vouchers/${id}/resend`, { method: 'POST' } as RequestInit);
    if (res.error) throw new Error(res.error);
  },
};
